module.exports = __webpack_public_path__ + "static/media/Mantis.a0cc95b1.png";